import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
//import CardMedia from '@material-ui/core/CardMedia';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
      padding: 20,
      paddingTop:100,
  },
  card: {
    //padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
      //margin: theme.spacing(2),
      alignItems: 'center',
  },
    button: {
         //padding: theme.spacing(2),
      //margin: theme.spacing(2),
        alignItems: 'center',
        //maxWidth: 75,
    },
    cardContent: {
        paddingTop: theme.spacing(0),
        paddintBottom: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    cardAction: {
      justifyContent: 'center',  
       paddingTop: theme.spacing(1),
        paddintBottom: theme.spacing(0),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      margin: theme.spacing(0),
    },
    media: {
        width: 70,
    },
    select: {
      minWidth: 250,
    }
}));

export default function QuestionCard(props) {
    const classes = useStyles();
    const [explanation, setExplanation] = useState(props.question.explanation);
    const [showSaveButton, setShowSaveButton] = useState(false);
    
    // DISPLAY BUTTONS IF DEFINED AS BUTTONS
    function displayAnswerButtons() {
        return props.question.answers.map((answer,index)=>{
            if (index===props.question.choice) {
                return <Button className={classes.button} value={props.index} key={answer} onClick={()=>props.onAnswerClick(props.question, index)}>{answer}</Button>
            }
            return <Button className={classes.button} color="secondary" value={props.index} key={answer} onClick={()=>props.onAnswerClick(props.question, index)}>{answer}</Button>
        });
    }

    // DISPLAY DROP DOWN IF DEFINED, MAINLY FOR SURVEYS THAT HAVE LONG ANSWER CHOICES OR MORE COMPLEX
    function displayAnswerSelect() {
      const menuItems = props.question.answers.map((answer, index)=><MenuItem value={index} key={answer}>{answer}</MenuItem>);

      return <>
      <InputLabel htmlFor="choices">Choices</InputLabel>
      <Select labelWidth={100} key={props.question} id="choices" value={props.question.choice} onChange={(e)=>props.onAnswerClick(props.question,e.target.value)}>
        {menuItems}
      </Select>
      </>;
    }

    function handleTextExplanationChange(event) {
      setShowSaveButton(true);
      setExplanation(event.target.value);
    }

    function saveButton() {
      return showSaveButton ? <Button variant="outlined" color="inherit" size="small" onClick={handleSaveClicked}>Save</Button>
      : null;
    }

    function clearButton() {
      return <Button variant="outlined" color="inherit" size="small" onClick={handleClearClicked}>Clear</Button>
    }

    function handleSaveClicked() {
      setShowSaveButton(false);
      // send info save
      props.onExplanationClick(props.question, explanation);
    }

    function handleTextBlur() { //When text field not focused
      setShowSaveButton(false);
      // send info save
      props.onExplanationClick(props.question, explanation);
    }

    function handleKeyPress(event) {
      if (event.key==="Enter") {
        event.preventDefault();
        handleSaveClicked();
      }
    }

    function handleClearClicked() {
      setShowSaveButton(false);
      // send info to clear
      setExplanation("");
      props.onExplanationClick(props.question, "");
      
    }

    // SHOW BUTTON GROUP BY DEFAULT, BUT IF SELECT SHOW SELECT OPTIONS
    function displayChoices() {
      if (props.type==="select") {
        return <>
        <FormControl className={classes.select}>
            {displayAnswerSelect()}
        </FormControl>
        </>;
      } 
      return <>
        <ButtonGroup variant="contained" color="primary" size="small">
            {displayAnswerButtons()}
        </ButtonGroup>
        </>;

    }

    return <>
        <Grid item xs={12} key={props.question.text}>
            <Card className={classes.card} key={props.question.text}>
                <CardContent className={classes.cardContent} key={props.question.text}>
                        <Typography variant="h6" color="inherit">{props.number}) <label>{props.question.text}</label></Typography>
                </CardContent>
                <CardActions className={classes.cardAction}>
                {displayChoices()}  
                </CardActions>
                <CardActions className={classes.cardAction}>
                  <TextField id="explanation" fullWidth label="Explanation" value={explanation} onChange={handleTextExplanationChange} onBlur={handleTextBlur} onKeyPress={handleKeyPress}/>
                  {saveButton()}{" "} {clearButton()}
                </CardActions>
            </Card>
          </Grid>
    </>;
}
